import * as React from 'react'
// libs
import { Link } from 'react-router-dom'
// styles
import './styles.css'

const LearnMoreButton = () => (
  <Link
    to='/contact'
    className='learn-more-button'
    state={{ theme: 'light', hideHeader: true }}
  >
    Learn More
  </Link>
)

export default LearnMoreButton
